/**
 * 🔹 SingleTransactionPage
 *
 * This component is used to display a single transaction.
 *
 * 📌 **Contexte d'utilisation :**
 * - it is used in the `Transaction` feature.
 * - it is used in the `Wallet` feature.
 *
 *
 * 🏷️ **Props :**
 *
 *
 * 📌 **Exemple d'utilisation :**
 * ```tsx
 * ```
 *
 * @component
 */
import React from "react";
import useQueryURL from "../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import SingleTransaction from "../../../features/wallet/components/wallets/SingleTransaction";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import { TransactionType } from "../../../features/wallet/types/transaction.types";

export const SINGLE_TRANSACTION_MODAL_ID = "single-transaction-modal";

export default function SingleTransactionPage() {
  return (
    <div>
      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Créer le",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_created_at" />
              ),
            },
            {
              title: "Statut",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_status" />
              ),
            }
          ]}
        />
        <TextBox
          content={[
            {
              title: "Montant de la transaction",
              TextRender: () => (
                <>
               < SingleTransaction.Info info="w_transaction_type" renderComponent={({value} ) => {
                const valueType = value as TransactionType;
                return (
                  <>
                    <span style={{ fontWeight: "bold", margin:0, padding:0, fontSize: "1.2rem", color: valueType === "DEPOSIT" ? "green" : '#7F2525' }}>
                    {valueType === "DEPOSIT" ? "+" : "-"}
                    <SingleTransaction.Info info="w_transaction_amount" />
                    </span>
                  </>
                );
              }}/>
               </>
              ),
            },
            {
              title: "Devise",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_currency" />
              ),
            },
          ]}
        />
      </div>
      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Méthode de paiement",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_paiement_method" />
              ),
            },
            {
              title: "Paiement ID / Transfer ID",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_payment_id" />
              ),
            }
          ]}
        />
       
      </div>
      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Description",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_description" />
              ),
            },
            {
              title: "Type de transaction",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_type" />
              ),
            }
          ]}
        />
      </div>
      <div
        style={{
          height: "70px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "ID de la transaction",
              TextRender: () => (
                <SingleTransaction.Info info="w_transaction_id" />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}

export const SingleTransactionDrawer = ({
  modalId,
  children,
}: {
  modalId?: string;
  children?: React.ReactNode;
}) => {
  const modalIdFound = modalId || SINGLE_TRANSACTION_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue(["transactionId", modalIdFound]);
  };

  return (
    <>
      <ModalDrawer
        urlParamName={modalIdFound}
        title={"Transaction"}
        onClose={onClose}
      >
        {children}
      </ModalDrawer>
    </>
  );
};
